import { func } from 'prop-types'
import React from 'react'
import OrganizationDetail from '../detailTypes/OrganizationDetail'

export function DataOverview() {
    return (
        <OrganizationDetail />
    )
}